export const LIST = "LIST";
export const OPTION_DATA = "OPTION_DATA";
export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const UPDATE_ANSWER = "UPDATE_ANSWER";
export const PAYOUT = "PAYOUT";